<div class="documents-container space-y-6">
  <!-- Seccion DNI (Superior) -->
  <app-dni-section
    [userId]="userId"
    [user]="user"
    (dniUpdated)="onDniUpdated()">
  </app-dni-section>

  <!-- Seccion Documentos Generales (Inferior) -->
  <app-general-documents-list
    #documentsListComponent
    [userId]="userId"
    (openModal)="onOpenDocumentModal($event)"
    (closeModalEvent)="onCloseDocumentModal()"
    (openConfirmation)="onOpenConfirmation($event)">
  </app-general-documents-list>
</div>
